<template>
  <PageHero
  :title="$t('hero.title_news')"
  :breadcrumbsTop="[
    { label: $t('hero.breadcrumbs.home'), link: '/' },
    { label: $t('hero.breadcrumbs.news') }
  ]"
  />
  <section class="module ptb-100">
    <div class="container">
      <div v-if="news" class="news-article">

        <!-- Заголовок -->
        <h1 class="fw-bold mb-3">{{ news.title }}</h1>

        <!-- Категория и дата -->
        <ul class="list-inline text-muted small mb-4">
          <li class="list-inline-item" v-if="news.category">📁 {{ news.category.name }}</li>
          <li class="list-inline-item">🕒 {{ formattedDate }}</li>
        </ul>

        <!-- Изображение -->
        <div v-if="news.image_url" class="mb-4">
          <img
            :src="news.image_url"
            alt="Новость"
            class="img-fluid rounded shadow-sm"
            style="max-height: 400px; object-fit: cover; width: 100%;"
          />
        </div>

        <!-- Контент -->
        <div class="news-content" v-html="news.content"></div>

        <!-- Кнопка "Назад" -->
        <div class="mt-4 text-start">
          <a class="btn btn-outline-primary" href="/public/news">
            ← Назад ко всем новостям
          </a>
        </div>
      </div>

      <div v-else class="text-center text-muted mt-5">Загрузка новости...</div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import PageHero from '../components/PageHero.vue'

const news = ref(null)

const formattedDate = computed(() => {
  if (!news.value?.published_at) return ''
  return new Date(news.value.published_at).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
})

onMounted(async () => {
  try {
    const pathParts = window.location.pathname.split('/')
    const id = pathParts[pathParts.length - 1]
    const response = await fetch(`/api/v1/news/${id}.json`)
    const data = await response.json()
    news.value = data
  } catch (error) {
    console.error('Ошибка загрузки новости:', error)
  }
})
</script>

<style scoped>
.news-content p {
  margin-bottom: 1rem;
  line-height: 1.6;
  font-size: 1rem;
}

.news-content h2,
.news-content h3 {
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.news-content ul,
.news-content ol {
  margin-bottom: 1rem;
  padding-left: 1.5rem;
}
</style>
